export const INICIAR_SESION = 'INICIAR_SESION'
export const CERRAR_SESION = 'CERRAR_SESION'
export const MODIFICAR_INPUTS_SIGNIN_PAGE = 'MODIFICAR_INPUTS_SIGNIN_PAGE'
export const ASIGNAR_USUARIO_SESION = 'ASIGNAR_USUARIO_SESION'
export const PROCESAMIENTO_SIGNIN_PAGE = 'PROCESAMIENTO_SIGNIN_PAGE'
export const LIMPIAR_MENSAJES = 'LIMPIAR_MENSAJES'
export const MOSTRAR_MENSAJE = 'MOSTRAR_MENSAJE'
export const MOSTRAR_MODAL_ERROR = 'MOSTRAR_MODAL_ERROR'
export const EXPANDIR_CONTRAER_MODULO = 'EXPANDIR_CONTRAER_MODULO'
export const MOSTRAR_MODAL_SELECTOR = 'MOSTRAR_MODAL_SELECTOR'
export const OCULTAR_MODAL_SELECTOR = 'OCULTAR_MODAL_SELECTOR'
export const MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR = 'MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR'
export const ACTUALIZAR_LISTADO_SELECTOR = 'ACTUALIZAR_LISTADO_SELECTOR'
export const MODIFICAR_PAGINA_MODAL_SELECTOR = 'MODIFICAR_PAGINA_MODAL_SELECTOR'
export const REINICIAR_LISTA_MODAL_SELECTOR = 'REINICIAR_LISTA_MODAL_SELECTOR'
export const ACTUALIZAR_STORE_PARAMETROS = 'ACTUALIZAR_STORE_PARAMETROS'
export const MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION = 'MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION'
export const MODAL_CONFIRMAR_ACCION = 'MODAL_CONFIRMAR_ACCION'
export const ADICIONAR_FILTRO_MODAL_SELECTOR = 'ADICIONAR_FILTRO_MODAL_SELECTOR'
//------
export const MOSTRAR_MODAL_SELECTOR_AIRPORT = 'MOSTRAR_MODAL_SELECTOR_AIRPORT'
export const OCULTAR_MODAL_SELECTOR_AIRPORT = 'OCULTAR_MODAL_SELECTOR_AIRPORT'
export const MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT = 'MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT'
export const ACTUALIZAR_LISTADO_SELECTOR_AIRPORT = 'ACTUALIZAR_LISTADO_SELECTOR_AIRPORT'
export const MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT = 'MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT'
export const REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT = 'REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT'
//----


//Admin Parametros
export const OBTENER_ADMIN_PARAMETROS = 'OBTENER_ADMIN_PARAMETROS'
export const CONMUTAR_SELECCION_ADMIN_PARAMETRO = 'CONMUTAR_SELECCION_ADMIN_PARAMETRO'
export const CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS = 'CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS'
export const FILTRAR_ADMIN_PARAMETROS = 'FILTRAR_ADMIN_PARAMETROS'
export const ORDENAR_ADMIN_PARAMETROS = 'ORDENAR_ADMIN_PARAMETROS'
export const MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO = 'MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO'
export const MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS = 'MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS'
export const DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS = 'DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS'
export const CREAR_ACTUALIZAR_ADMIN_PARAMETRO = 'CREAR_ACTUALIZAR_ADMIN_PARAMETRO'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO'
export const ELIMINAR_ADMIN_PARAMETRO = 'ELIMINAR_ADMIN_PARAMETRO'
export const ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO = 'ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO'
export const ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO = 'ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO'

//Usuarios
export const OBTENER_USUARIOS = 'OBTENER_USUARIOS'
export const CONMUTAR_SELECCION_USUARIO = 'CONMUTAR_SELECCION_USUARIO'
export const CONMUTAR_SELECCION_TODOS_USUARIOS = 'CONMUTAR_SELECCION_TODOS_USUARIOS'
export const FILTRAR_USUARIOS = 'FILTRAR_USUARIOS'
export const ORDENAR_USUARIOS = 'ORDENAR_USUARIOS'
export const MOSTRAR_MODAL_CREAR_USUARIO = 'MOSTRAR_MODAL_CREAR_USUARIO'
export const MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS = 'MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS'
export const DESHABILITAR_BOTON_MODAL_USUARIOS = 'DESHABILITAR_BOTON_MODAL_USUARIOS'
export const CREAR_ACTUALIZAR_USUARIO = 'CREAR_ACTUALIZAR_USUARIO'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO'
export const ELIMINAR_USUARIO = 'ELIMINAR_USUARIO'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS'
export const ADICIONAR_CRITERIO_FILTRADO_USUARIOS = 'ADICIONAR_CRITERIO_FILTRADO_USUARIOS'
export const ELIMINAR_CRITERIO_FILTRADO_USUARIOS = 'ELIMINAR_CRITERIO_FILTRADO_USUARIOS'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS'
export const MODIFICAR_CRITERIO_FILTRADO_USUARIOS = 'MODIFICAR_CRITERIO_FILTRADO_USUARIOS'
export const APLICAR_CRITERIOS_FILTRADO_USUARIOS = 'APLICAR_CRITERIOS_FILTRADO_USUARIOS'
export const CAMBIAR_MOSTRAR_REGISTROS_USUARIOS = 'CAMBIAR_MOSTRAR_REGISTROS_USUARIOS'
export const MODIFICAR_INPUTS_USUARIOS = 'MODIFICAR_INPUTS_USUARIOS'

//Parametros
export const OBTENER_PARAMETROS = 'OBTENER_PARAMETROS'
export const OBTENER_PARAMETRO = 'OBTENER_PARAMETRO'
export const MODIFICAR_INPUTS_PARAMETROS = 'MODIFICAR_INPUTS_PARAMETROS'
export const ADICIONAR_NUEVO_DETALLE_PARAMETRO = 'ADICIONAR_NUEVO_DETALLE_PARAMETRO'
export const CONMUTAR_SELECCION_TODOS_PARAMETROS = 'CONMUTAR_SELECCION_TODOS_PARAMETROS'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO'

//Solicitudes
export const OBTENER_SOLICITUDES = 'OBTENER_SOLICITUDES'
export const CONMUTAR_SELECCION_SOLICITUD = 'CONMUTAR_SELECCION_SOLICITUD'
export const CONMUTAR_SELECCION_TODOS_SOLICITUDES = 'CONMUTAR_SELECCION_TODOS_SOLICITUDES'
export const FILTRAR_SOLICITUDES = 'FILTRAR_SOLICITUDES'
export const ORDENAR_SOLICITUDES = 'ORDENAR_SOLICITUDES'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_SOLICITUD'
export const ELIMINAR_SOLICITUD = 'ELIMINAR_SOLICITUD'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_SOLICITUDES'
export const ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES = 'ADICIONAR_CRITERIO_FILTRADO_SOLICITUDES'
export const ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES = 'ELIMINAR_CRITERIO_FILTRADO_SOLICITUDES'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_SOLICITUDES'
export const MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES = 'MODIFICAR_CRITERIO_FILTRADO_SOLICITUDES'
export const APLICAR_CRITERIOS_FILTRADO_SOLICITUDES = 'APLICAR_CRITERIOS_FILTRADO_SOLICITUDES'
export const CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES = 'CAMBIAR_MOSTRAR_REGISTROS_SOLICITUDES'

//Creacion solicitudes de servicio
export const REINICIAR_SOLICITUD_SERVICIO = 'REINICIAR_SOLICITUD_SERVICIO'
export const MODIFICAR_INPUTS_SOLICITUD_SERVICIO = 'MODIFICAR_INPUTS_SOLICITUD_SERVICIO'
export const MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO = 'MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD'
export const OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO = 'OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO'
export const ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM = 'ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO'
export const ELIMINAR_ITEMS_SOLICITUD_SERVICIO = 'ELIMINAR_ITEMS_SOLICITUD_SERVICIO'
export const CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO = 'CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO'
export const OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO = 'OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO'
export const ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO = 'ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO'
export const MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO = 'MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO'
export const RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO = 'RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO'
export const ENVIAR_COMENTARIO_SOLICITUD_SERVICIO = 'ENVIAR_COMENTARIO_SOLICITUD_SERVICIO'
export const EDITAR_COMENTARIO_SOLICITUD_SERVICIO = 'EDITAR_COMENTARIO_SOLICITUD_SERVICIO'
export const ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO = 'ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO'

//Solicitud de servicio
export const ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO = 'ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO'
export const OBTENER_SOLICITUD_SERVICIO = 'OBTENER_SOLICITUD_SERVICIO'
export const MODIFICAR_INPUTS_SOLICITUD_SERVICIO1 ='MODIFICAR_INPUTS_SOLICITUD_SERVICIO1'
export const ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO = 'ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO'
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO'
export const ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO = 'ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_SERVICIO'
export const DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO = 'DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_SERVICIO'
export const ACTUALIZAR_SOLICITUD_SERVICIO = 'ACTUALIZAR_SOLICITUD_SERVICIO'
export const CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO = 'CONMUTAR_RECOMENDACION_COTIZACION_SERVICIO'
export const CONMUTAR_SELECCION_APROBACION_SERVICIO = 'CONMUTAR_SELECCION_APROBACION_SERVICIO'
export const MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO = 'MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO'
export const ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO = 'ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO'
export const REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO = 'REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO'
export const DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO = 'DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO'
export const ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1 = 'ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO1'
export const ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO = 'ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO'
export const SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO = 'SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_SERVICIO'
export const MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO = 'MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_SOLICITUD_SERVICIO'
export const MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 = 'MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD1'
export const OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO1 = 'OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD1'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1 = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO1'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1 = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO1'
export const ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1 = 'ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM1'
export const DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO = 'DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO'
export const ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1 = 'ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_SERVICIO1'
export const EDITAR_COMENTARIO_SOLICITUD_SERVICIO1 = 'EDITAR_COMENTARIO_SOLICITUD_SERVICIO1'
export const DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1 = 'DESHABILITAR_BOTON_ENVIAR_COMENTARIO_SERVICIO1'

// Creacion de solicitud de bienes e investigacion
export const REINICIAR_SOLICITUD_BIENES_INVESTIGACION = 'REINICIAR_SOLICITUD_BIENES_INVESTIGACION'
export const MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION = 'MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION'
export const MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION = 'MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION'
export const ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION = 'ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION'
export const CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION = 'CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION'
export const CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION = 'CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION'
export const ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM = 'ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION'
export const OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION = 'OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION'
export const ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION = 'ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION'
export const ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION = 'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION'
export const CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION = 'CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION'
export const ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION = 'ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION'
export const EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION = 'EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION'
export const ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION = 'ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION'


// Solicitud de bienes e investigación
export const OBTENER_SOLICITUD_BIENES_INVESTIGACION = 'OBTENER_SOLICITUD_BIENES_INVESTIGACION'
export const MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1 = 'MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1'
export const DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION = 'DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION'
export const SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION = 'SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION'
export const SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION = 'SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION'
export const REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION = 'REMOVER_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION'
export const CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION = 'CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION'
export const CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION = 'CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION'
export const MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION = 'MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION'
export const ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION = 'ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION'
export const DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION = 'DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION'
export const MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION = 'MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION'
export const ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION1 = 'ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION1'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1 = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1'
export const CONMUTAR_SELECCION_TODOS_BIENES = 'CONMUTAR_SELECCION_TODOS_BIENES'
export const REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION = 'REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION'
export const DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION = 'DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION'
export const SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1= 'SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1'
export const ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 = 'ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1'
export const EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1 = 'EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1'
export const DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1 = 'DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1'
export const ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1 = 'ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1'

//Creacion Solicitud de servicio - Oficina tecnica
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT'
export const REINICIAR_SOLICITUD_SERVICIO_OT = 'REINICIAR_SOLICITUD_SERVICIO_OT'
export const MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT = 'MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT'
export const MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT = 'MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD'
export const OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT = 'OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT'
export const ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM = 'ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT'
export const ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT = 'ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT'
export const CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT = 'CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT'
export const OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT = 'OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT'
export const ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT = 'ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT'
export const MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT = 'MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT'
export const RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT = 'RECARGAR_LISTA_ARCHIVOS_SOLICITUD_SERVICIO_OT'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT'
export const ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT = 'ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT'
export const ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT = 'ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT'
export const REINICIAR_VALORES_AIU = 'REINICIAR_VALORES_AIU'
export const REINICIAR_VALORES_IVA = 'REINICIAR_VALORES_IVA'
export const ENVIAR_COMENTARIO_SOLICITUD_OT = 'ENVIAR_COMENTARIO_SOLICITUD_OT'
export const EDITAR_COMENTARIO_SOLICITUD_OT = 'EDITAR_COMENTARIO_SOLICITUD_OT'
export const ELIMINAR_COMENTARIO_SOLICITUD_OT = 'ELIMINAR_COMENTARIO_SOLICITUD_OT'


//Solicitud de servicio - Oficina técnica
export const OBTENER_SOLICITUD_SERVICIO_OT = 'OBTENER_SOLICITUD_SERVICIO_OT'
export const ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT = 'ADICIONAR_MODIFICACION_SOLICITUD_SERVICIO_OT'
export const ACTUALIZAR_SOLICITUD_SERVICIO_OT = 'ACTUALIZAR_SOLICITUD_SERVICIO_OT'
export const MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT = 'MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT'
export const MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1 = 'MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT1'
export const ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT = 'ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT'
export const REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT = 'REMOVER_GARANTIA_DOCUMENTO_SOLICITUD_SERVICIO_OT'
export const DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT = 'DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_SERVICIO_OT'
export const MOSTRAR_MODAL_RESUMEN_SOLICITUD_SERVICIO_OT = 'MOSTRAR_MODAL_RESUMEN_SOLICITUD_SERVICIO_OT'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1 = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT1'
export const ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1 = 'ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT1'
export const REINICIAR_SOLICITUD_SERVICIO_OT1 = 'REINICIAR_SOLICITUD_SERVICIO_OT1'
export const MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 = 'MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1'
export const OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT1 = 'OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD1'
export const ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1 = 'ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT1'
export const DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT = 'DESHABILITAR_BOTONES_APROBACION_SOLICITUD_SERVICIO_OT'
export const SELECCIONAR_MONEDA_SOLICITUD_OT1 = 'SELECCIONAR_MONEDA_SOLICITUD_OT1'
export const ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1 = 'ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_OT1'
export const EDITAR_COMENTARIO_SOLICITUD_OT1 = 'EDITAR_COMENTARIO_SOLICITUD_OT1'
export const DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1 = 'DESHABILITAR_BOTON_ENVIAR_COMENTARIO_OT1'

//Plantillas
export const OBTENER_PLANTILLAS = 'OBTENER_PLANTILLAS'
export const CONMUTAR_SELECCION_PLANTILLA = 'CONMUTAR_SELECCION_PLANTILLA'
export const CONMUTAR_SELECCION_TODOS_PLANTILLAS = 'CONMUTAR_SELECCION_TODOS_PLANTILLAS'
export const FILTRAR_PLANTILLAS = 'FILTRAR_PLANTILLAS'
export const ORDENAR_PLANTILLAS = 'ORDENAR_PLANTILLAS'
export const MOSTRAR_MODAL_CREAR_PLANTILLA = 'MOSTRAR_MODAL_CREAR_PLANTILLA'
export const MODIFICAR_INPUTS_PLANTILLAS = 'MODIFICAR_INPUTS_PLANTILLAS'
export const DESHABILITAR_BOTON_MODAL_PLANTILLAS = 'DESHABILITAR_BOTON_MODAL_PLANTILLAS'
export const CREAR_ACTUALIZAR_PLANTILLA = 'CREAR_ACTUALIZAR_PLANTILLA'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA'
export const ELIMINAR_PLANTILLA = 'ELIMINAR_PLANTILLA'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS'
export const ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS = 'ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS'
export const ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS = 'ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS'
export const MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS = 'MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS'
export const APLICAR_CRITERIOS_FILTRADO_PLANTILLAS = 'APLICAR_CRITERIOS_FILTRADO_PLANTILLAS'
export const CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS = 'CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS'

//Garantias
export const OBTENER_GARANTIAS = 'OBTENER_GARANTIAS'
export const CONMUTAR_SELECCION_GARANTIA = 'CONMUTAR_SELECCION_GARANTIA'
export const CONMUTAR_SELECCION_TODOS_GARANTIAS = 'CONMUTAR_SELECCION_TODOS_GARANTIAS'
export const FILTRAR_GARANTIAS = 'FILTRAR_GARANTIAS'
export const ORDENAR_GARANTIAS = 'ORDENAR_GARANTIAS'
export const MOSTRAR_MODAL_CREAR_GARANTIA = 'MOSTRAR_MODAL_CREAR_GARANTIA'
export const MODIFICAR_INPUTS_GARANTIAS = 'MODIFICAR_INPUTS_GARANTIAS'
export const DESHABILITAR_BOTON_MODAL_GARANTIAS = 'DESHABILITAR_BOTON_MODAL_GARANTIAS'
export const CREAR_ACTUALIZAR_GARANTIA = 'CREAR_ACTUALIZAR_GARANTIA'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA'
export const ELIMINAR_GARANTIA = 'ELIMINAR_GARANTIA'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS'
export const ADICIONAR_CRITERIO_FILTRADO_GARANTIAS = 'ADICIONAR_CRITERIO_FILTRADO_GARANTIAS'
export const ELIMINAR_CRITERIO_FILTRADO_GARANTIAS = 'ELIMINAR_CRITERIO_FILTRADO_GARANTIAS'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS'
export const MODIFICAR_CRITERIO_FILTRADO_GARANTIAS = 'MODIFICAR_CRITERIO_FILTRADO_GARANTIAS'
export const APLICAR_CRITERIOS_FILTRADO_GARANTIAS = 'APLICAR_CRITERIOS_FILTRADO_GARANTIAS'
export const CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS = 'CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS'


//Creacion solicitudes de contrato anual
export const REINICIAR_SOLICITUD_CONTRATOANUAL = 'REINICIAR_SOLICITUD_CONTRATOANUAL'
export const MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL = 'MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL'


//Solicitud de Contrato anual
export const REINICIAR_SOLICITUD_CONTRATOANUAL1 = 'REINICIAR_SOLICITUD_CONTRATOANUAL1'
export const OBTENER_SOLICITUD_CONTRATOANUAL = 'OBTENER_SOLICITUD_CONTRATOANUAL'
export const MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1 = 'MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1'
export const ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL = 'ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL'
export const MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL = 'MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL'
export const ACTUALIZAR_SOLICITUD_CONTRATOANUAL = 'ACTUALIZAR_SOLICITUD_CONTRATOANUAL'
export const MOSTRAR_MODAL_ADICION_FIRMAS = 'MOSTRAR_MODAL_ADICION_FIRMAS'
export const DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO = 'DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO'


//Adjuntos - common
export const MOSTRAR_MODAL_AGREGAR_ARCHIVO = 'MOSTRAR_MODAL_AGREGAR_ARCHIVO'
export const OCULTAR_MODAL_AGREGAR_ARCHIVO = 'OCULTAR_MODAL_AGREGAR_ARCHIVO'
export const MODIFICAR_INPUTS_ARCHIVO = 'MODIFICAR_INPUTS_ARCHIVO'
export const MODIFICAR_INPUTS_COMMON_REDUCER = 'MODIFICAR_INPUTS_COMMON_REDUCER'
export const DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA = 'DESHABILITAR_BOTON_MODAL_ADICIONAR_FACTURA'
export const CONMUTAR_SELECCION_TODOS_ITEMS_FILES = 'CONMUTAR_SELECCION_TODOS_ITEMS_FILES'
export const REMOVER_ARCHIVOS_SOLICITUD = 'REMOVER_ARCHIVOS_SOLICITUD'

//Aprobaciones proveedores
export const OBTENER_EXTERNOS_APROBACIONES = 'OBTENER_EXTERNOS_APROBACIONES'
export const CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES = 'CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_APROBACIONES'
export const FILTRAR_EXTERNOS_APROBACIONES = 'FILTRAR_EXTERNOS_APROBACIONES'
export const ORDENAR_EXTERNOS_APROBACIONES = 'ORDENAR_EXTERNOS_APROBACIONES'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES'
export const MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES = 'MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES'
export const APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES = 'APLICAR_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_APROBACIONES'
export const ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES = 'ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES'
export const ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES = 'ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_APROBACIONES'
export const MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES = 'MOSTRAR_MODAL_RESUMEN_EXTERNOS_APROBACIONES'
export const MODIFICAR_INPUTS_EXTERNOS_APROBACIONES = 'MODIFICAR_INPUTS_EXTERNOS_APROBACIONES'

//Cotizaciones proveedores
export const OBTENER_EXTERNOS_COTIZACIONES = 'OBTENER_EXTERNOS_COTIZACIONES'
export const CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES = 'CAMBIAR_MOSTRAR_REGISTROS_EXTERNOS_COTIZACIONES'
export const FILTRAR_EXTERNOS_COTIZACIONES = 'FILTRAR_EXTERNOS_COTIZACIONES'
export const ORDENAR_EXTERNOS_COTIZACIONES = 'ORDENAR_EXTERNOS_COTIZACIONES'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES'
export const MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES = 'MODIFICAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES'
export const APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES = 'APLICAR_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_EXTERNOS_COTIZACIONES'
export const ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES = 'ADICIONAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES'
export const ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES = 'ELIMINAR_CRITERIO_FILTRADO_EXTERNOS_COTIZACIONES'
export const MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES = 'MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES'
export const MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES = 'MODIFICAR_INPUTS_EXTERNOS_COTIZACIONES'
export const ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES = 'ADICIONAR_NUEVO_ARCHIVO_EXTERNOS_COTIZACIONES'

export const MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD = 'MOSTRAR_MODAL_RESUMEN_EXTERNOS_COTIZACIONES_SOLICITUD'


//Documentos
export const MOSTRAR_MODAL_RESUMEN_DOCUMENTO = 'MOSTRAR_MODAL_RESUMEN_DOCUMENTO'
export const MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO = 'MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO'
export const MODIFICAR_INPUTS_DOCUMENTOS = 'MODIFICAR_INPUTS_DOCUMENTOS'
export const DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS = 'DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS'
export const MOSTRAR_MODAL_ADICIONA_FACTURA_DOCUMENTO = 'MOSTRAR_MODAL_ADICIONA_FACTURA_DOCUMENTO'
export const MOSTRAR_MODAL_ADICIONAR_ADICIONAL = 'MOSTRAR_MODAL_ADICIONAR_ADICIONAL'
export const ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO = 'ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO'
export const ELIMINAR_ARCHIVOS_DOCUMENTO = 'ELIMINAR_ARCHIVOS_DOCUMENTO'
export const MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO = 'MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO'



//Adiciones
export const ADICIONAR_NUEVO_CENCO_ADICIONAL = 'ADICIONAR_NUEVO_CENCO_ADICIONAL'
export const ELIMINAR_CENCOS_ADICIONAL = 'ELIMINAR_CENCOS_ADICIONAL'
export const DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION = 'DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION'

//Facturas
export const MOSTRAR_MODAL_ADICIONA_FACTURA = 'MOSTRAR_MODAL_ADICIONA_FACTURA'
export const MOSTRAR_MODAL_ULTIMA_FACTURA = 'MOSTRAR_MODAL_ULTIMA_FACTURA'

//VerificacionSST
export const MOSTRAR_MODAL_ADICION_VERIFICACION_SST = 'MOSTRAR_MODAL_ADICION_VERIFICACION_SST'

//Tiquetes Aereos
export const REINICIAR_SOLICITUD_TIQUETESAEREO = 'REINICIAR_SOLICITUD_TIQUETESAEREO'
export const MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO = 'MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_TRAYECTO = 'ADICIONAR_TRAYECTO'
export const ADICIONAR_TRAYECTO1 = 'ADICIONAR_TRAYECTO1'
export const REMOVER_TRAYECTOS = 'REMOVER_TRAYECTOS'
export const REMOVER_TRAYECTOS1 = 'REMOVER_TRAYECTOS1'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_PASAPORTE = 'ADICIONAR_PASAPORTE'
export const OBTENER_SOLICITUD_TIQUETESAEREO = 'OBTENER_SOLICITUD_TIQUETESAEREO'
export const MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO = 'MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO'
export const REMOVER_COTIZACION_TIQUETESAEREO = 'REMOVER_COTIZACION_TIQUETESAEREO'
export const MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1 = 'MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO = 'ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_COTIZACION_TIQUETESAEREO = 'ADICIONAR_COTIZACION_TIQUETESAEREO'
export const DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO = 'DESHABILITAR_BOTON_CREAR_DOCUMENTO_SOLICITUD_TIQUETESAEREO'
export const ACTUALIZAR_SOLICITUD_TIQUETESAEREO = 'ACTUALIZAR_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1 = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1'
export const SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO = 'SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO'
export const MOSTRAR_MODAL_ADICIONAR_TIQUETE = 'MOSTRAR_MODAL_ADICIONAR_TIQUETE'
export const MODIFICAR_TIQUETE = 'MODIFICAR_TIQUETE'
export const MOSTRAR_MODAL_ADICIONAR_ASISTENCIA = 'MOSTRAR_MODAL_ADICIONAR_ASISTENCIA'
export const MODIFICAR_ASISTENCIA = 'MODIFICAR_ASISTENCIA'
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO'
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1 = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1'
export const REMOVER_CENCOS_TIQUETESAEREOS = 'REMOVER_CENCOS_TIQUETESAEREOS'
export const REMOVER_CENCOS_TIQUETESAEREOS1 = 'REMOVER_CENCOS_TIQUETESAEREOS1'
export const EDITAR_ARCHIVO_PASAPORTE = 'EDITAR_ARCHIVO_PASAPORTE'
export const MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO = 'MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO'
export const ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO = 'ENVIAR_COMENTARIO_SOLICITUD_TIQUETESAEREO'
export const EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO = 'EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO'
export const ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO = 'ELIMINAR_COMENTARIO_SOLICITUD_TIQUETESAEREO'
export const ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 = 'ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1'
export const EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1 = 'EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1'
export const DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1 = 'DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1 = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1'
export const ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO = 'ELIMINAR_ARCHIVOS_SOLICITUD_TIQUETESAEREO'


//Hoteles
export const REINICIAR_SOLICITUD_HOTELES = 'REINICIAR_SOLICITUD_HOTELES'
export const MODIFICAR_INPUTS_SOLICITUD_HOTELES = 'MODIFICAR_INPUTS_SOLICITUD_HOTELES'
export const ADICIONAR_ALOJAMIENTO = 'ADICIONAR_ALOJAMIENTO'
export const REMOVER_ALOJAMIENTOS = 'REMOVER_ALOJAMIENTOS'
export const DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES = 'DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES'
export const OBTENER_SOLICITUD_HOTELES = 'OBTENER_SOLICITUD_HOTELES'
export const MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES = 'MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES'
export const REMOVER_COTIZACION_HOTELES = 'REMOVER_COTIZACION_HOTELES'
export const MODIFICAR_INPUTS_SOLICITUD_HOTELES1 = 'MODIFICAR_INPUTS_SOLICITUD_HOTELES1'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES'
export const ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1 = 'ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1'
export const ADICIONAR_MODIFICACION_SOLICITUD_HOTELES = 'ADICIONAR_MODIFICACION_SOLICITUD_HOTELES'
export const ADICIONAR_COTIZACION_HOTELES = 'ADICIONAR_COTIZACION_HOTELES'
export const DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES = 'DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES'
export const ACTUALIZAR_SOLICITUD_HOTELES = 'ACTUALIZAR_SOLICITUD_HOTELES'
export const ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES = 'ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES'
export const SELECCIONAR_APROBACION_SOLICITUD_HOTELES = 'SELECCIONAR_APROBACION_SOLICITUD_HOTELES'
export const MOSTRAR_MODAL_ADICIONAR_RESERVACION = 'MOSTRAR_MODAL_ADICIONAR_RESERVACION'
export const MODIFICAR_RESERVACION = 'MODIFICAR_RESERVACION'
export const ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES = 'ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES'
export const REMOVER_CENCOS_HOTELES = 'REMOVER_CENCOS_HOTELES'
export const ENVIAR_COMENTARIO_SOLICITUD_HOTELES = 'ENVIAR_COMENTARIO_SOLICITUD_HOTELES'
export const EDITAR_COMENTARIO_SOLICITUD_HOTELES = 'EDITAR_COMENTARIO_SOLICITUD_HOTELES'
export const ELIMINAR_COMENTARIO_SOLICITUD_HOTELES = 'ELIMINAR_COMENTARIO_SOLICITUD_HOTELES'
export const ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1 = 'ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1'
export const EDITAR_COMENTARIO_SOLICITUD_HOTELES1 = 'EDITAR_COMENTARIO_SOLICITUD_HOTELES1'
export const DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1 = 'DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1'
export const ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES = 'ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES'


//OTROSI
export const OBTENER_SOLICITUD_OTROSI = 'OBTENER_SOLICITUD_OTROSI'
export const MOSTRAR_MODAL_CREATE_OTROSI = 'MOSTRAR_MODAL_CREATE_OTROSI'
export const RESETEAR_REDUCER_SOLICITUD_OTROSI = 'RESETEAR_REDUCER_SOLICITUD_OTROSI'



//Grupos
export const OBTENER_GRUPOS = 'OBTENER_GRUPOS'
export const CONMUTAR_SELECCION_GRUPO = 'CONMUTAR_SELECCION_GRUPO'
export const CONMUTAR_SELECCION_TODOS_GRUPOS = 'CONMUTAR_SELECCION_TODOS_GRUPOS'
export const FILTRAR_GRUPOS = 'FILTRAR_GRUPOS'
export const ORDENAR_GRUPOS = 'ORDENAR_GRUPOS'
export const MOSTRAR_MODAL_CREAR_GRUPO = 'MOSTRAR_MODAL_CREAR_GRUPO'
export const MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS = 'MODIFICAR_INPUTS_MODAL_CREATE_GRUPOS'
export const DESHABILITAR_BOTON_MODAL_GRUPOS = 'DESHABILITAR_BOTON_MODAL_GRUPOS'
export const CREAR_ACTUALIZAR_GRUPO = 'CREAR_ACTUALIZAR_GRUPO'
export const MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO = 'MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GRUPO'
export const ELIMINAR_GRUPO = 'ELIMINAR_GRUPO'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_GRUPOS'
export const ADICIONAR_CRITERIO_FILTRADO_GRUPOS = 'ADICIONAR_CRITERIO_FILTRADO_GRUPOS'
export const ELIMINAR_CRITERIO_FILTRADO_GRUPOS = 'ELIMINAR_CRITERIO_FILTRADO_GRUPOS'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_GRUPOS'
export const MODIFICAR_CRITERIO_FILTRADO_GRUPOS = 'MODIFICAR_CRITERIO_FILTRADO_GRUPOS'
export const APLICAR_CRITERIOS_FILTRADO_GRUPOS = 'APLICAR_CRITERIOS_FILTRADO_GRUPOS'
export const CAMBIAR_MOSTRAR_REGISTROS_GRUPOS = 'CAMBIAR_MOSTRAR_REGISTROS_GRUPOS'
export const MODIFICAR_INPUTS_GRUPOS = 'MODIFICAR_INPUTS_GRUPOS'
export const SELECCIONAR_ITEM_GRUPOS = 'SELECCIONAR_ITEM_GRUPOS'

//Busqueda documento
export const BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS = 'BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS'
export const BUSQUEDADOCUMENTO_REINICIAR_ESTADO = 'BUSQUEDADOCUMENTO_REINICIAR_ESTADO'
export const BUSQUEDADOCUMENTO_MODIFICAR_INPUTS = 'BUSQUEDADOCUMENTO_MODIFICAR_INPUTS'

//Reportes
export const ADICIONAR_CRITERIO_FILTRADO_REPORTES = 'ADICIONAR_CRITERIO_FILTRADO_REPORTES'
export const APLICAR_CRITERIOS_FILTRADO_REPORTES = 'APLICAR_CRITERIOS_FILTRADO_REPORTES'
export const CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES = 'CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES'
export const ELIMINAR_CRITERIO_FILTRADO_REPORTES = 'ELIMINAR_CRITERIO_FILTRADO_REPORTES'
export const MODIFICAR_CRITERIO_FILTRADO_REPORTES = 'MODIFICAR_CRITERIO_FILTRADO_REPORTES'
export const MODIFICAR_INPUTS_REPORTES = 'MODIFICAR_INPUTS_REPORTES'
export const MODIFICAR_NUMERO_REGISTROS_MOSTRAR = 'MODIFICAR_NUMERO_REGISTROS_MOSTRAR'
export const MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES = 'MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES'
export const OBTENER_EVALUACION_PROVEEDOR = 'OBTENER_EVALUACION_PROVEEDOR'
export const OBTENER_MONTO_CONTRATADO_PROVEEDOR = 'OBTENER_MONTO_CONTRATADO_PROVEEDOR'
export const OBTENER_MONTO_CONTRATADO_CENCO = 'OBTENER_MONTO_CONTRATADO_CENCO'
export const OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS = 'OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS'
export const OBTENER_RADICADOS = 'OBTENER_RADICADOS'
export const OBTENER_GESTION_RESPONSABLE_COMPRAS = 'OBTENER_GESTION_RESPONSABLE_COMPRAS'
export const ORDENAR_REPORTES = 'ORDENAR_REPORTES'

//Cambio contrasena
export const MODIFICAR_INPUTS_CAMBIO_CONTRASENA = 'MODIFICAR_INPUTS_CAMBIO_CONTRASENA'

//Configuracion de maestras
export const OBTENER_MAESTRAS = 'OBTENER_MAESTRAS'
export const MOSTRAR_MODAL_ADICIONAR_MAESTRA = 'MOSTRAR_MODAL_ADICIONAR_MAESTRA'
export const CONMUTAR_SELECCION_MAESTRAS = 'CONMUTAR_SELECCION_MAESTRAS'
export const CONMUTAR_SELECCION_TODAS_MAESTRAS = 'CONMUTAR_SELECCION_TODAS_MAESTRAS'
export const MODIFICAR_INPUTS_MAESTRA = 'MODIFICAR_INPUTS_MAESTRA'

export const MOSTRAR_MODAL_PROGRESS = 'MOSTRAR_MODAL_PROGRESS'

//Configuracion asignacion delegados
export const MOSTRAR_MODAL_ADICIONAR_DELEGADOS = 'MOSTRAR_MODAL_ADICIONAR_DELEGADOS'
export const OBTENER_DELEGADOS = 'OBTENER_DELEGADOS'
export const CONMUTAR_SELECCION_DELEGADOS = 'CONMUTAR_SELECCION_DELEGADOS'
export const CONMUTAR_SELECCION_TODOS_DELEGADOS = 'CONMUTAR_SELECCION_TODOS_DELEGADOS'
export const MODIFICAR_INPUTS_DELEGADOS = 'MODIFICAR_INPUTS_DELEGADOS'
export const RESET_MODAL_ADD_DELEGADO = 'RESET_MODAL_ADD_DELEGADO'
export const ORDENAR_DELEGADOS = 'ORDENAR_DELEGADOS'
export const CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS = 'CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS'
export const ADMINDB_POBLAR_RESULTADOS = 'ADMINDB_POBLAR_RESULTADOS'
export const MODIFICAR_INPUTS_ADMINDB = 'MODIFICAR_INPUTS_ADMINDB'
export const ADMINDB_RESETEAR_TABLA = 'ADMINDB_RESETEAR_TABLA'
export const SELECCIONAR_TIPO_SOLICITUD = 'SELECCIONAR_TIPO_SOLICITUD'


export const SEARCHING_AIRPORTS = 'SEARCHING_AIRPORTS'



// WEBPACK FOOTER //
// ./src/actions/types.js